<div class="wrapper">    
    <h1>אנחנו שומרים על הפרטיות שלך!</h1>
    <img src="./assets/icons/locked.png" alt="lochked">
    <div class="bodyMessage">
    <p class="p1">עקב ריבוי ניסיונות וכדי להגן על חשבונך, </p>
    <p class="p1">הכניסה למערכת נחסמה זמנית. </p>
    <p class="p1">ניתן להיכנס בשנית בעוד זמן מה. </p>
    <!-- <p class="p2">ניתן להיכנס בשנית בעוד זמן מה </p>  change from p2 to p1 - remove reEntry lock user button-->
     </div>
    <!-- <p-button label="כניסה מחדש" [disabled]="disableButton" (click)="reEntry()">
    </p-button> -->
</div>
